import request from './request'

export default class OrganizerSettingApi {
  async getAvailableOrganizations() {
    return await request(
      {
        environment: '/organizerSettings',
        type: 'query',
        name: 'getAvailableOrganizations',
        way: './graphql/organizerSettings/',
        has_catch: true
      }
    )
  }
  /**
   * deprecate
   */
  async getForceBpmAdditionalData(model) {
    return await request(
      {
        environment: '/organizerSettings',
        type: 'query',
        name: 'getForceBpmAdditionalData',
        variables: {model},
        way: './graphql/organizerSettings/',
        has_catch: true}
    )
  }
  /**
   * deprecate
   */
  async getForceBpmProcessRow(model) {
    return await request(
      {
        environment: '/organizerSettings',
        type: 'query',
        name: 'getForceBpmProcessRow',
        variables: {model},
        way: './graphql/organizerSettings/',
        has_catch: true}
    )
  }
  async getOrganizationUsers(organizationId) {
    const result = await request(
      {
        environment: '/organizerSettings',
        type: 'query',
        name: 'getOrganizationUsers',
        variables: {organizationId},
        way: './graphql/organizerSettings/',
        has_catch: true}
    )

    result?.forEach(element => {
      delete element['__typename']
    })
    return result
  }
  async getOrganizerSettingDetail(model) {
    const result = await request(
      {
        environment: '/organizerSettings',
        type: 'query',
        name: 'getOrganizerSettingDetail',
        variables: {model},
        way: './graphql/organizerSettings/',
        has_catch: true}
    )

    result?.users?.forEach(element => {
      delete element.userInfo['__typename']
      delete element['__typename']
    })
    return result
  }
  async getOrganizerSettings(model) {
    return await request(
      {
        environment: '/organizerSettings',
        type: 'query',
        name: 'getOrganizerSettings',
        variables: {model},
        way: './graphql/organizerSettings/',
        has_catch: true}
    )
  }

  async getOrganizerSettingStatistics(model) {
    model.settingsIds = []
    return await request(
      {
        environment: '/organizerSettings',
        type: 'query',
        name: 'getOrganizerSettings',
        variables: {model},
        callback: (res) => res?.data ? res?.data?.getOrganizerSettings : res,
        way: './graphql/organizerSettings/',
        has_catch: true}
    )
  }
  async getSettingDetailView(settingId, organizationId) {
    return await request(
      {
        environment: '/organizerSettings',
        type: 'query',
        name: 'getSettingDetailView',
        variables: {settingId, organizationId},
        way: './graphql/organizerSettings/',
        has_catch: true}
    )
  }
  async getSettingView() {
    return await request(
      {
        environment: '/organizerSettings',
        type: 'query',
        name: 'getSettingView',
        way: './graphql/organizerSettings/',
        has_catch: true}
    )
  }
  async searchOrganizers(searchPhrase) {
    return await request(
      {
        environment: '/organizerSettings',
        type: 'query',
        name: 'searchOrganizers',
        variables: {searchPhrase},
        way: './graphql/organizerSettings/',
        has_catch: true}
    )
  }



  async addOrganizerSetting(model) {
    return await request({
      environment: '/organizerSettings',
      type: 'mutation',
      name: 'addOrganizerSetting',
      variables: {model},
      way: './graphql/organizerSettings/',
    })
  }
  async copyOrganizationSetting(model) {
    return await request({
      environment: '/organizerSettings',
      type: 'mutation',
      name: 'copyOrganizationSetting',
      variables: {settingOrganizationId: model.settingOrganizationId, toOrganizationId: model.toOrganizationId},
      way: './graphql/organizerSettings/',
    })
  }
  async copyOrganizationSettings (model) {
    return await request({
      environment: '/organizerSettings',
      type: 'mutation',
      name: 'copyOrganizationSettings',
      variables: {fromOrganizationId: model.fromOrganizationId, toOrganizationId: model.toOrganizationId, settingsIds: model.settingsIds || []},
      way: './graphql/organizerSettings/',
    })
  }
  async deleteOrganizerSetting (model) {
    return await request({
      environment: '/organizerSettings',
      type: 'mutation',
      name: 'deleteOrganizerSetting',
      variables: {model},
      way: './graphql/organizerSettings/',
    })
  }
  async editOrganizerSetting (model) {
    model.users.forEach(element => {
      delete element.settingUserId
    })
    return await request({
      environment: '/organizerSettings',
      type: 'mutation',
      name: 'editOrganizerSetting',
      variables: {model},
      way: './graphql/organizerSettings/',
    })
  }
}
